import { appContext } from "../../../AppContext";
import { BaseComponent } from "@iconics/components";

export abstract class IbssComponent<TProps, TState> extends BaseComponent<TProps, TState>
{
    public async loading(action: () => Promise<void>): Promise<void>
    {
        try
        {
            appContext().state.set({ isLoading: true });
            await action();
        }
        finally
        {
            appContext().state.set({ isLoading: false });
        }
    }
}
